module.exports = __webpack_public_path__ + "static/media/icon-cwb-logo-full.8af76c56.svg";